import { Flex } from "@aircall/tractor";
import styled, { getColor, css } from "@xstyled/styled-components";

import { Mode } from "../../InputChoices.decl";

export const StyledFlex = styled(Flex)<{
  mode: Mode;
  disabled: boolean;
  active: boolean;
}>`
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

  // Border illusion between elements.
  &:not(:last-child) {
    border-right: 1px solid ${getColor("graphic-default")};
  }

  ${({ mode, active }) => {
    switch (mode) {
      case "binary":
        return css`
          // Left.
          &:first-child {
            background-color: ${
              active ? getColor("graphic-interactive-primary") : "initial"
            };

            &:hover {
              background-color: ${
                active
                  ? getColor("graphic-interactive-primary-hover")
                  : getColor("surface-interactive-primary-ghost-hover")
              };
            }
          }

          // Right.
          &:last-child {
            background-color: ${
              active ? getColor("graphic-interactive-critical") : "initial"
            };

            &:hover {
              background-color: ${
                active
                  ? getColor("graphic-interactive-critical-hover")
                  : getColor("surface-interactive-primary-ghost-hover")
              };
            }
          }
        `;
      case "multiple":
        return css`
          background-color: ${
            active ? getColor("graphic-interactive-secondary") : "initial"
          };

          &:hover {
            background-color: ${
              active
                ? getColor("graphic-interactive-secondary-hover")
                : getColor("surface-interactive-primary-ghost-hover")
            };
          }
        `;

      default:
        break;
    }
  }}

  ${({ disabled }) =>
    disabled &&
    css`
      &:hover {
        background-color: transparent !important;
      }
    `}
`;
